import { ModelInsideQuiz } from "api"
import { Fragment } from "react"
import styled from "styled-components"
import QuizGame from "./QuizGame"

const StyledQuiz = styled.div`
  padding-right: 16px;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-top: 80px;
  padding-bottom: 50px;
  position: relative;
  background-color: ${(p) => p.theme.colors.black};
  align-items: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`
type QuizzesProps = {
  data: ModelInsideQuiz
}

const Quizzes = ({ data }: QuizzesProps) => {
  return (
    <StyledQuiz>
      {data?.quizItems.map((item, index) => (
        <Fragment key={`quiz${index}`}>
          {item.title && <QuizGame quizData={item} />}
        </Fragment>
      ))}
    </StyledQuiz>
  )
}

export default Quizzes
